<template>
<span id="reactivate-all" v-if="isVisible()">
  <el-button
    id="btn-reactivate-all"
    type="success"
    plain
    @click="handleReactivateAll()"
    size="mini"
    v-show="displayButton"
  >
    {{ $t('outbound.units.reactivateAll') }}
  </el-button>
</span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Message } from 'element-ui';
import moment from 'moment';
import constants from '@/utils/constants';
import {
  OUTBOUND_UNITS_REACTIVATE_ALL,
  OUTBOUND_UNITS_SEARCH,
  OUTBOUND_UNITS_VALIDATE_REACTIVATE_ALL
} from '@/store/actions';

export default {
  name: 'ReactivateAll',
  props: {
    displayButton: Boolean,
  },
  computed: {
    ...mapGetters([
      'outboundUnits'
    ])
  },
  methods: {
    ...mapActions({
      validateReactivateAll: OUTBOUND_UNITS_VALIDATE_REACTIVATE_ALL,
      reactivateAll: OUTBOUND_UNITS_REACTIVATE_ALL,
      search: OUTBOUND_UNITS_SEARCH,
    }),
    isVisible() {
      const hasReactivateUnitPermission = this.$can(this.permissions.DATA_ENTRY.REACTIVATE_UNIT);
      const thereAreRowsInGrid = this.outboundUnits.list.length > 0;
      return hasReactivateUnitPermission && thereAreRowsInGrid && !this.outboundUnits.actualFilters.active;
    },
    async confirmValidation() {
      let validationConfirm = false;
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      const validationResponse = await this.validateReactivateAll().catch(() => {
      });
      if (validationResponse > 0) {
        const dosFrom = this.outboundUnits.actualFilters.dayOfServiceFrom;
        const dosTo = this.outboundUnits.actualFilters.dayOfServiceTo
          ? this.outboundUnits.actualFilters.dayOfServiceTo : this.outboundUnits.actualFilters.dayOfServiceFrom;

        validationConfirm = await this.$confirm(
          this.$t('outbound.units.reactivateAllConfirm')
            .replace('[numberOfUnits]', validationResponse)
            .replace('[shipDateFrom]', moment(dosFrom).format(constants.DATES.DEFAULT_DISPLAY_FORMAT))
            .replace('[shipDateTo]', moment(dosTo).format(constants.DATES.DEFAULT_DISPLAY_FORMAT)),
          { confirmButtonText: this.$t('outbound.units.reactivateAll'), dangerouslyUseHTMLString: true }
        ).catch(() => {
        });
      }
      loading.close();
      return validationConfirm;
    },
    async handleReactivateAll() {
      Message.closeAll();

      // Check number units to reactivate
      const confirm = await this.confirmValidation();
      if (!confirm) {
        return;
      }

      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      try {
        const response = await this.reactivateAll().catch(() => {
        });
        this.$message.success(response.message);
        this.search({});
        this.dialogVisible = false;
      } finally {
        loading.close();
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#reactivate-all #btn-reactivate-al {
  margin-right: 10px;
}
</style>
